import React from "react";
import styles from "./EngenCaresSustainability.module.scss";
import { Layout, NavigationBanner, Section, SectionList } from "../../../components";
import useFetchB2B from "../../../helpers/useFetchB2B";
import b2bRoutes from "../../../helpers/b2b.routes";

const EngenCaresSustainability = () => {
  const { sortedSection, currentPage, pages } = useFetchB2B({
    url: b2bRoutes.ENGENCARES,
  });

  return (
    <Layout pageTitle="Sustainability" withBottomPadding={false} backButton={true}>
      {currentPage ? (
        <>
          <NavigationBanner pages={pages} activePage={currentPage} />
          <div className={styles.main}>
            <div className={styles.columnedBlock}>
              {sortedSection[0] && <Section section={sortedSection[0]} />}
              {sortedSection[1] && <Section section={sortedSection[1]} />}
              {sortedSection[2] && <Section section={sortedSection[2]} pdfType="arrowIcon" />}
            </div>
            {sortedSection[3] && <Section section={sortedSection[3]} />}
          </div>
          {sortedSection[4] && <SectionList sections={sortedSection.slice([4])} />}
        </>
      ) : null}
    </Layout>
  );
};

export default EngenCaresSustainability;
